(function () {
  const STORAGE_KEY = 'pepx_researcher_verified';

  function readVerification() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const data = JSON.parse(raw);
      if (!data || !data.verified || !data.expiresAt) return null;
      if (Date.now() >= data.expiresAt) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return data;
    } catch {
      return null;
    }
  }

  function writeVerification(expiryDays) {
    const days = Number(expiryDays) || 30;
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        verified: true,
        expiresAt: Date.now() + days * 24 * 60 * 60 * 1000
      })
    );
  }

  function markVerified() {
    document.documentElement.classList.add('age-gate-verified');
  }

  function showGate() {
    document.documentElement.classList.remove('age-gate-verified');
  }

  function initAgeGate() {
    const gate = document.querySelector('[data-age-gate]');
    if (!gate) return;

    const expiryDays = gate.dataset.expiryDays || '30';
    const form = gate.querySelector('[data-age-gate-form]');
    const submitBtn = gate.querySelector('[data-age-gate-submit]');
    const checks = gate.querySelectorAll('[data-age-gate-check]');

    if (readVerification()) {
      markVerified();
      return;
    }

    showGate();

    const updateSubmitState = () => {
      const allChecked = Array.from(checks).every((input) => input.checked);
      if (submitBtn) submitBtn.disabled = !allChecked;
    };

    checks.forEach((input) => {
      input.addEventListener('change', updateSubmitState);
    });

    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      if (submitBtn?.disabled) return;
      writeVerification(expiryDays);
      markVerified();
    });

    updateSubmitState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAgeGate);
  } else {
    initAgeGate();
  }
})();
